import React, {useEffect, useState} from "react";
import './Seguimiento.css';
import { Select, List, Col, Row, Skeleton, Button, Progress, Input, message, Upload, Spin, Modal } from "antd";
import { Tooltip } from '@material-ui/core';
import { EyeOutlined, PlusOutlined, UploadOutlined } from "@ant-design/icons";
import Mensajes from "../../../components/Mensajes/Mensajes";
import FormActaSeguimiento from '../../../components/FormActaSeguimiento/FormActaSeguimiento';
import useAuth from "../../../hooks/useAuth";
import { Redirect } from 'react-router';
import { consultaTablaSeguimiento, getTiposDocumentacionSeguimiento, procesaCargaMasiva, procesaCargaMasivaSeguimiento } from "../../../api/seguimiento";

const { Option } = Select;



export default function SeguimientoProduccion(props) {
    
    let tiempoMensaje = 20;
    
    const { user } = useAuth();

    const roUsario = localStorage.getItem("ROL_USUARIO");

    const isCargaMasiva = (roUsario === "DOCSYMAT.ADMIN.OC" || roUsario === "DOCSYMAT.CAPTURA.OC"
        || roUsario === "DOCSYMAT.CAPTURA.OPLE.JL" || roUsario === "DOCSYMAT.CAU.OC")

    const isConsulta = roUsario === 'DOCSYMAT.CONSULTA.OC' ? true :
            roUsario === 'DOCSYMAT.CAPTURA.JL' ? true :
                roUsario === 'DOCSYMAT.CONSULTA.JL' ? true :
                    roUsario === 'DOCSYMAT.CONSULTA.UTVOPL.OC' ? true :
                        roUsario === 'DOCSYMAT.CONSULTA.OPLE.JL' ? true :
                            roUsario === 'DOCSYMAT.SUPERVISOR.OC' ? true :
                                roUsario === 'DOCSYMAT.REVISOR.OC' ? true : false;

    const  isCau = roUsario === 'DOCSYMAT.CAU.OC' ? true : false;

    const [loadingCargaMasiva,          setLoadingCargaMasiva]      = useState(false);
    const [modalVisible,                setModalVisible]            = useState(false);
    const [modalEmpresaVisible,         setModalEmpresaVisible]     = useState(false);
    const [loadingTabla,                setLoadingTabla]            = useState(false);
    const [idTipoDocumentacion,         setIdTipoDocumentacion]     = useState(0);
    const [refreshTable,                setRefreshTable]            = useState(false);
    const [listaTabla,                  setListaTabla]              = useState([]);
    const [listaTablaCopy,              setListaTablaCopy]          = useState([]);
    const [disabledFiltro,              setDisabledFiltro]          = useState(true)
   
    const [options, setOptions] = useState({
        data: [],
        loadingData: false
    });


    const [visibleAlert, setVisibleAlert] = useState({
        activado: false,
        tipoMensaje: "",
        mensaje: ""
    });

    const [redirect, setRedirect] = useState({
        redirecting: false,
        url: "",
        idArticulo: -1,
        idTipoDocumentacion: -1,
        nombreArticulo: "",
    });


    const [archivoCargaMasiva,     setArchivoCargaMasiva]     = useState({
        uploading: false,
        file: "",
        urlPDF: null,
        mostrarModal: false,
    });

    const [fileList,setFileList] = useState([]);

    //PROPIEDADES DEL BOTÓN DE CARGA MASIVA
    const propsCargaMasiva = {
        multiple: false,
        fileList: fileList,
        onChange: file =>{
            if (file.fileList.length > 1) {
                setFileList([file.fileList[file.fileList.length - 1]]);
            } else {
                setFileList(file.fileList);
            }
        },
        onRemove: file => {
            setArchivoCargaMasiva(archivoDisenioU => {
                return {
                    file: archivoDisenioU.file
                };
            });
        },
        beforeUpload: file => {
            let isCSV = file.type === 'application/vnd.ms-excel';
            isCSV = isCSV | file.type === 'text/csv';
            const isSomething = file.size > 0;
            const isSize = (file.size / 1024 / 1024) < 50;
            if (!isCSV) {
               message.error("El formato del archivo no corresponde a un CSV. Favor de borrarlo y cargar uno válido.",tiempoMensaje);
                return true;
            }
            if (!isSomething) {
                message.error("El archivo se encuentra vacío. Favor de borrarlo y cargar uno válido.",tiempoMensaje);
                return true;
            }
            if (!isSize) {
                message.error("El archivo pesa más de 50 MB. Favor de borrarlo y cargar uno válido.",tiempoMensaje);
                return false;
            }
            if (isCSV && isSomething && isSize) {
                setArchivoCargaMasiva({
                    file:  file,
                    uploading: archivoCargaMasiva.uploading,
                    mostrarModal:true
                });
                
            }
            return false;
        },
        archivoCargaMasiva
    };

    //ACCIONES QUE SE EJECUTAN AUTOMATICAMENTE AL CARGAR EL COMPONENTE
    useEffect(()=>{
        //Se obtiene la lista de tipos de clacificación
        getTiposDocumentacion(); 
        //Si existe un idTipoDocumentación desde que se ingresa al módulo entonces se carga la tabla
        if((props.location.state.hasOwnProperty('idTipoDocumentacion') && props.location.state.idTipoDocumentacion !=null) ){
            setIdTipoDocumentacion(props.location.state.idTipoDocumentacion)
            setRefreshTable(true)
        }
    },[])

    //ACCIONES QUE SE EJECUTAN AL CAMBIAR EL ESTADO DE rfreshTable
    useEffect(()=>{
        if(refreshTable)
            handleSelect(idTipoDocumentacion)
    },[refreshTable])
    

    // MÉTODO QUE OBTIENE EL LISTADO DE TIPOS DE CLASIFICACIÓN
    const getTiposDocumentacion = () =>{
        let data = JSON.stringify({
            idProceso: localStorage.getItem('ID_PROCESO_ELECTORAL'),
            idDetalleProceso: localStorage.getItem('ID_DETALLE_PROCESO')
        })
       getTiposDocumentacionSeguimiento(data)
            .then(resp => {
                if (resp.data.entity.code === 200) {
                    setOptions({
                        data: resp.data.entity.listaTipoDocumentacion,
                        loadingData: true
                    })
                }
                else if (resp.data.entity.code === 403) {
                    localStorage.clear();
                    window.location = "/login"
                }
                else {                    
                    message.error(resp.data.entity.causa, tiempoMensaje);
                }
            }).catch(err => {
                if (err.response !== null && err.response.status === 403) {
                    localStorage.clear();
                    window.location = "/login"
                    return;
                }
                
                message.error("Ocurrió un error al obtener la clasificación de elección. Favor de intentar más tarde.", tiempoMensaje);
            })

    }
    
    const handleClose = () => {
        setVisibleAlert({
            activado: false,
            tipoMensaje: "",
            mensaje: ""
        });
    }

    //MÉTODO QUE OBTIENE EL LISTADO DE LA TABLA AL SELECCIONAR UN TIPO DE CLASIFICACIÓN
    const handleSelect = (value) => {

        if (value.length !== 0) {
            setLoadingTabla(true);
            setIdTipoDocumentacion( parseInt(value));

            let data = JSON.stringify({
                idEstado: parseInt(localStorage.getItem('ID_ESTADO_SELECCIONADO')),
                idTipoDocumentacion: parseInt(value),
                idProceso: localStorage.getItem('ID_PROCESO_ELECTORAL'),
                idDetalleProceso: localStorage.getItem('ID_DETALLE_PROCESO'),
            })

            consultaTablaSeguimiento(data)
                .then(resp => {
                    if (resp.data.entity.code === 200) {
                        setLoadingTabla(false);
                        setRefreshTable(false)
                        setDisabledFiltro(false);
                        setListaTabla(resp.data.entity.tablaConsultaSeguimiento)
                        setListaTablaCopy(resp.data.entity.tablaConsultaSeguimiento)
                    }
                    else if (resp.data.entity.code === 403) {
                        localStorage.clear();
                        window.location = "/login"
                    }
                    else {
                        message.error(resp.data.entity.causa, tiempoMensaje);
                    }
                }).catch(err => {
                    if (err.response != null && err.response.status === 403) {
                        localStorage.clear();
                        window.location = "/login"
                        return;
                    }
                    setLoadingTabla(false);
                    setRefreshTable(false)
                    setListaTabla([])
                    setListaTablaCopy([])
                    
                    message.error("Ocurrió un error al obtener los documentos y materiales. Favor de intentar más tarde.", tiempoMensaje);
                })
        } else {
            setLoadingTabla(false);
            setDisabledFiltro(true);
            setListaTabla([]);
            setListaTablaCopy([])
        }
    }

    /**MÉTODO PARA LOS FILTROS DE LA TABLA */
    const handleSearch = (value) => {
        //Para filtrar los datos se usa una copia de la lista ya que ecesitamos siempre la lista original
        const tablaFiltrada = listaTablaCopy.filter(listaTabla => listaTabla.nombreArticulo.toLowerCase()
            .replace("á", "a").replace("é", "e").replace("í", "i").replace("ó", "o").replace("ú", "u")
            .includes(value.toLowerCase()
                .replace("á", "a").replace("é", "e").replace("í", "i").replace("ó", "o").replace("ú", "u")))

        setListaTabla(tablaFiltrada);
    };

    const abrirModal = (item) => {
        localStorage.setItem("ID_ARTICULO_SEG", item.idArticulo);
        localStorage.setItem("ID_TIPO_DOC_SEG", item.idTipoDocumentacion);
        localStorage.setItem("ID_APROBACION_SEG", item.idAprobacion);
        localStorage.setItem("NOMBRE_ARTICULO_SEG", item.nombreArticulo);
        setModalVisible(true);
    }


    const abrirVentanaDescripcion = (item) => {
        localStorage.setItem("ID_ARTICULO_SEG", item.idArticulo);
        localStorage.setItem("ID_TIPO_DOC_SEG", item.idTipoDocumentacion);
        localStorage.setItem("ID_APROBACION_SEG", item.idAprobacion);
        localStorage.setItem("NOMBRE_ARTICULO_SEG", item.nombreArticulo);
        setRedirect({
            redirecting: true,
            url: '/produccion/consultaseguimiento',
            idArticulo: item.idArticulo,
            idTipoDocumentacion: item.idTipoDocumentacion,
            nombreArticulo: item.nombreArticulo,
        })
    }

    const handleModalEnviarCargaMasiva = () => {
        const formData = new FormData();
        setLoadingCargaMasiva(true);
        setArchivoCargaMasiva({
            ...archivoCargaMasiva,
            mostrarModal:false,
        })
        formData.append('idProcesoElectoral', user.infoMenu.detalleSelec.idProcesoElectoral);
        formData.append('idDetalleProceso', user.infoMenu.detalleSelec.idDetalleProceso);
        formData.append('idEstado', user.infoMenu.detalleSelec.idEstado);
        formData.append('nombreEstado', user.infoMenu.estadoSelec.nombreEstado);
        formData.append('anio', user.infoMenu.detalleSelec.anio);
        formData.append('tipoProceso', user.infoMenu.detalleSelec.tipoProceso);
        formData.append('idTipoDocumentacion', idTipoDocumentacion);
        formData.append('archivo.archivo', archivoCargaMasiva.file);
        formData.append('usuario', user.user.sub)
        procesaCargaMasivaSeguimiento(formData)
            .then(response => {
                setLoadingCargaMasiva(false);
                if (response.data.entity.code !== 200 && response.data.entity.code !== 403) {
                    if (response.data.entity.causa !== null)
                        message.error(
                                response.data.entity.causa
                                    // El mensaje de error tiene una bandera que indica de donde provino el error
                                    .replace("SISTEMA", "VALIDADO CONTRA EL SISTEMA: ")
                                    .replace("ARCHIVO", "VALIDADO CONTRA EL ARCHIVO: "),
                                tiempoMensaje
                        );
                    else
                        message.error("10. Ocurrió un error. Comunícate al CAU", tiempoMensaje);
                }
                else if (response.data.entity.code === 200) {
                    setArchivoCargaMasiva({
                        uploading: false,
                        file: "",
                        urlPDF: null,
                    })
                    setFileList([])
                    message.success("La carga de archivos concluyó correctamente.", tiempoMensaje)
                    setRefreshTable(true)//Se actualiza la lista de articulos de la tabla
                }
                else {
                    localStorage.clear();
                    // console.log("Borro el local storage");
                    window.location = "/login"
                }
            })
            .catch(error => {
                setLoadingCargaMasiva(false);
                message.error("Ha ocurrido un error al realizar la petición solicitada.", tiempoMensaje);
            })

    }

    //MÉTODO QUE SE EECUTA AL CANCELAR LA CARGA MASIVA DESDE EL MODAL
    const handleModalCancelCargaMasiva = () => {
        setArchivoCargaMasiva({
         ...archivoCargaMasiva,
         mostrarModal:false,
        })
     }

    //METODO QUE CAMBIA DE VENTANA AL COMPONENTE DE LA URL ESPECIFICADO
    const renderRedirect = () => {
        if (redirect.redirecting) {
            return <Redirect to={{
                pathname: redirect.url,
                state: {
                    idArticulo: redirect.idArticulo,
                    nombreArticulo: redirect.nombreArticulo,
                    idTipoDocumentacion: redirect.idTipoDocumentacion,
                }
            }
            } />
        }
    }
        
        return (
            <div>
                <Spin tip='Procesando' spinning = {loadingCargaMasiva} size="large">
                {renderRedirect()}
                <Row>
                {
                    visibleAlert.activado ?
                        (
                            <Mensajes tipoMensaje={visibleAlert.tipoMensaje} mensaje={visibleAlert.mensaje} handleClose={handleClose} />
                        ) : null}
                <h1 className="titulo-seguimiento">Seguimiento a producción</h1>
                <label className="texto-14-seguimiento">Los datos con ( <label className="rojo-seguimiento">*</label> ) son requeridos.</label>
                <br />
                <br />
                <label className="texto-16-seguimiento"><label className="rojo-seguimiento">*</label> Tipo de clasificación de elección</label>
                <br />
                <br />
                    <Col span={12}>
                        <Select 
                            style={{ width: '100%' }} 
                            options={options.data} 
                            onSelect={handleSelect}
                            placeholder="Seleccione una opción" 
                            defaultValue={props.location.state.idTipoDocumentacion === null || props.location.state.idTipoDocumentacion === undefined ? "Seleccionar opción" : props.location.state.idTipoDocumentacion}
                            id="opcion"
                        >
                            {options.data.map((item, index) => {
                                return <Option id="opcion" key={item.idTipoDocumentacion}>{item.nombreDocumentacion}</Option>;
                            })}
                        </Select>
                    </Col>
                    {listaTabla && listaTabla.length > 0 && isCargaMasiva  &&
                    <Col span={4}>
                        <Upload {...propsCargaMasiva} accept=".csv">
                            <Tooltip title="Se permiten únicamente archivos en formato CSV">
                            <Button 
                            className="subirCargaMasiva" 
                            style={{minWidth: '150px'}}>
                                <UploadOutlined />Carga Masiva
                            </Button>
                            </Tooltip>
                        </Upload>
                    </Col>
                    }
                </Row>
                <br />
                <br />
                <List
                    header={
                        <Row className="header-tabla-gris">
                            <Col span={1} className="roboto-normal-16-white texto-centrado">
                                No.
                            </Col>
                            <Col span={8} className="roboto-normal-16-white">
                                Documento/Material
                                <br />
                                <Input disabled={disabledFiltro} className="filtro-header" onChange={(event) => handleSearch(event.target.value)} placeholder="Filtro" />
                            </Col>
                            <Col span={5} className="roboto-normal-16-white texto-centrado">
                                Tipo de elección
                            </Col>
                            <Col span={5} className="roboto-normal-16-white">
                                Porcentaje de avance
                            </Col>
                            <Col span={3} className="roboto-normal-16-white texto-centrado">
                                Avance del día
                            </Col>
                            <Col span={2} className="roboto-normal-16-white texto-centrado">
                                Acciones
                            </Col>
                        </Row>
                    }
                    pagination={{
                        pageSize: 6,
                    }}
                    size="large"
                    loading={loadingTabla}
                    itemLayout="horizontal"
                    dataSource={listaTabla}
                    renderItem={item =>
                       
                        <List.Item>
                            <Skeleton title={false} loading={loadingTabla} active>
                                <List.Item.Meta
                                    description={
                                        <Row>
                                            <Col span={1} className="texto-centrado">
                                                {item.consecutivo}
                                            </Col>
                                            <Col span={8}>
                                                {item.nombreArticulo}
                                            </Col>
                                            <Col span={5} className="texto-centrado">
                                                {item.nombreTipoEleccion}
                                            </Col>
                                            <Col span={5}>
                                                <Progress
                                                    strokeColor={{
                                                        from: item.colorPorcentaje === "4" ? "#808080": item.colorPorcentaje === "3" ? "#AB2525" : item.colorPorcentaje === "2" ? "#389b73" : "#1890ff",
                                                        to: item.colorPorcentaje === "4" ? "#808080": item.colorPorcentaje === "3" ? "#AB2525" : item.colorPorcentaje === "2" ? "#389b73" : "#1890ff",
                                                    }}
                                                    percent={parseFloat(item.porcentajeAvance)}
                                                />
                                            </Col>
                                            <Col span={3} className="texto-centrado">
                                                {item.avanceAlDia}
                                            </Col>
                                            <Col span={2} className="acciones-centrado">
                                                   <Tooltip title="Consultar"><Button disabled={item.porcentajeAvance > 0 ? false : true || false} type="link" onClick={()=>abrirVentanaDescripcion(item)} className="boton-circular-rosa"><EyeOutlined /></Button></Tooltip>
                                                    <Tooltip title="Capturar"><Button type="link" disabled={isConsulta} onClick={() =>abrirModal(item)} className="boton-circular-rosa"><PlusOutlined /></Button></Tooltip>
                                                
                                            </Col>
                                        </Row>
                                    }
                                />
                            </Skeleton>
                        </List.Item>
                    }
                />
                <FormActaSeguimiento
                    isVisible={modalVisible}
                    setIsVisible={setModalVisible}
                    isLoadingEmpresa={modalEmpresaVisible}
                    setIsLoadingEmpresa={setModalEmpresaVisible}
                    isCau={isCau}
                    setRefreshTable={setRefreshTable}
                />
                <Modal
                    visible={archivoCargaMasiva.mostrarModal}
                    title={ `¿Estás seguro que deseas iniciar la carga del archivo ${archivoCargaMasiva.file.name}?`}
                    //onOk={handleModalEnvíar}
                    onCancel={handleModalCancelCargaMasiva}
                    footer={[
                        <div className="justificacion-footer">
                            <Button 
                                key="back" 
                                onClick={handleModalCancelCargaMasiva} 
                                className="boton-modal-cancelar"
                            >
                                Cancelar
                            </Button>
                            <Button key="submit" type="primary"
                                onClick={handleModalEnviarCargaMasiva}
                                className="boton-modal-aceptar"
                            >
                                Aceptar
                            </Button>
                        </div>
                    ]}
                />
                </Spin>
            </div>
        );
}